export default __webpack_public_path__ + "static/media/ring.dcd62eae.png";